export const CONCEPT_DISPLAY = {
    ANIMATION_SPEED: 150,
    TOTAL_GIFS: 5,
    PREVIEW_PATH: '/concepts'
};

export const ANIMATIONS = {
    SLIDE: {
        LEFT: {
            IN: 'animate-slide-left-in',
            OUT: 'animate-slide-left-out'
        },
        RIGHT: {
            IN: 'animate-slide-right-in',
            OUT: 'animate-slide-right-out'
        }
    }
};